import { SingleSelect } from '@medly-components/core';
import styled from 'styled-components';

export const MedlySingleSelect = styled(SingleSelect)`
    ul {
        max-height: 25rem;
        overflow: auto;

        li {
            padding: 0.8rem 0.8rem;
            > span {
                white-space: unset !important;
            }
            > svg {
                > path {
                    fill: ${({ theme }) => theme.colors.coral[500]} !important;
                }
            }
        }
    }
`;

export const SelectWrapper = styled.div<{ maxHeight: number }>`
    ul {
        max-height: ${({ maxHeight }) => maxHeight}px;
    }
    &.top {
        ul {
            top: initial;
            bottom: 100%;
        }
    }
    input:not(:placeholder-shown) ~ label,
    input:focus ~ label {
        transform: translateY(-100%) !important;
        font-size: 1.2rem;
    }
`;
